
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/department-selection.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/department-selection.md?type=demo')
};